
setTimeout(() => {
    (function() {
        const currentContainer = document.querySelector('.shadeshop-product-listing-wrapper');
    if (!currentContainer) return;

    const loader = document.createElement('div');
    loader.className = 'collection-loader';
    loader.innerHTML = `<div class="spinner"></div>`;
    currentContainer.style.position = 'relative';
    currentContainer.appendChild(loader);
    setTimeout(() => {
            const mappings = {
        'custom-bestseller-smart': 'bestseller-smart',
        'custom-all-new-arrivals': 'all-new-arrivals',
        'custom-shop-all-style-men': 'shop-all-style-men'
    };

    function getMappedCollection() {
        for (const [bodyClass, handle] of Object.entries(mappings)) {
            if (document.body.classList.contains(bodyClass)) {
                return handle;
            }
        }
        return null;
    }

    function hasQueryParams() {
        return window.location.search && window.location.search.length > 0;
    }

    if (document.readyState === 'loading') {
        document.addEventListener('readystatechange', () => {
            if (document.readyState === 'interactive') {
                    startFetch();
            }
        });
    } else {
            startFetch();
    }

    async function startFetch() {
        const mappedHandle = getMappedCollection();
        if (!mappedHandle) {
            const loaderEl = document.querySelector('.collection-loader');
            if (loaderEl) loaderEl.remove(); 
            const filterContainer = document.querySelector('.filter-container');
            if (filterContainer) {
                filterContainer.classList.remove('opacity-0');
            }
            return;
        }

        const currentContainer = document.querySelector('.shadeshop-product-listing-wrapper');
        if (!currentContainer) return;

        const loader = document.createElement('div');
        loader.className = 'collection-loader';
        loader.innerHTML = `<div class="spinner"></div>`;
        currentContainer.style.position = 'relative';
        currentContainer.appendChild(loader);

        try {
            const response = await fetch(`/collections/${mappedHandle}`);
            if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

            const html = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            const newContainer = doc.querySelector('.shadeshop-product-listing-wrapper');
            if (newContainer) {
                currentContainer.replaceWith(newContainer);
            }
            
        } catch (error) {
            console.error('Error fetching mapped collection:', error);
        } finally {
            const loaderEl = document.querySelector('.collection-loader');
            if (loaderEl) loaderEl.remove(); 
        }
    }
    }, 1000);
})();
}, 500);
